<template>
  <div class="app-calendar overflow-hidden border">
    <div class="row no-gutters">
      <!-- Legend -->
      <div class="col-sm-12">
        <b-card>
          <b-card-title class="mb-1">Legend</b-card-title>
          <b-card-body>
            <b-badge variant="primary" class="mr-1">Delivered</b-badge>
            <b-badge variant="warning" class="mr-1">In Transit</b-badge>
            <b-badge variant="danger" class="mr-1">Pending</b-badge>
            <b-badge variant="dark" class="mr-1">Cancelled</b-badge>
            <b-badge variant="secondary" class="mr-1">Returned</b-badge>
           
            
          </b-card-body>
        </b-card>
      </div>
      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0">
            <full-calendar :plugins="calendarPlugins" :events="fcEvents" :options="calendarOptions" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BSidebar, BCard, BCardTitle, BCardBody, BBadge } from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import Sidebar from "./SidebarView.vue";
import { mapActions, mapGetters } from "vuex";
import { Tooltip } from "bootstrap";

export default {
  components: {
    FullCalendar,
    BButton,
    BSidebar,
    Sidebar,
    BCard,
    BCardTitle,
    BCardBody,
    BBadge,
  },
  data() {
    return {
      calendarPlugins: [dayGridPlugin],
      fcEvents: [],
      newstatus: false,
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        editable: true,
        selectable: true,
        events: [], // Events are populated dynamically
        eventsSet: (events) => {
          console.log("Events rendered on the calendar:", events);
        },
        eventClick: this.handleEventClick,
        eventContent: (info) => {
          // Create a card-like structure for the event
          const event = info.event;
          const driverName = event.extendedProps.driverName || "N/A";
          const pickUpLocation = event.extendedProps.pickUpLocation || "N/A";
          const dropOffLocation = event.extendedProps.dropOffLocation || "N/A";
          const deliveryStatus = event.extendedProps.deliveryStatus || "N/A";

          // Custom HTML for the event
          return {
            html: `
        <div class="custom-event-card" style="background-color: ${event.backgroundColor}; border-color: ${event.borderColor}; padding: 5px; border-radius: 5px; color: white;">
          <strong>Delivery (${deliveryStatus})</strong><br />
          <span><strong>Driver:</strong> ${driverName}</span><br />
          <span><strong>Pickup:</strong> ${pickUpLocation}</span><br />
          <span><strong>Drop off:</strong> ${dropOffLocation}</span>
        </div>
      `,
          };
        },
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,dayGridWeek,dayGridDay",
        },
        views: {
          dayGridWeek: {
            displayEventTime: false,
            allDaySlot: false,
          },
          dayGridDay: {
            displayEventTime: false, 
            allDaySlot: false, 
          },
          dayGridMonth: {
            displayEventTime: false,
          }
        },
        eventTimeFormat: {
          hour: "2-digit",
          minute: "2-digit",
          meridiem: false,
        },
      },

      showSidebar: false,
      selectedItem: null, // Initialize as null
    };
  },
  computed: {
    ...mapGetters("jobcardModule", {
      jobcardList: "jobcards",
      jobcardLoading: "loading",
    }),
    ...mapGetters("deliveriesModule", {
      deliveries: "delivery",
      deliveriesLoading: "loading",
    }),
  },
  methods: {
    ...mapActions("deliveriesModule", ["getDeliveryListAction"]),
    ...mapActions("jobcardModule", ["getJobcardListAction"]),
    setNewStatus(status) {
      this.newstatus = status;
      if (this.newstatus) {
        window.location.reload();
      }
    },
    handleEventClick(clickInfo) {
      const deliveryId = clickInfo.event.id; // Get the event ID
      if (deliveryId) {
        // Navigate to the specific route using Vue Router
        this.$router.push(`/delivery/DeliveryManagement/ViewDelivery/view-delivery/${deliveryId}`);
      }
    },
  },
  async mounted() {
    try {
      await this.getDeliveryListAction();
      console.log("Deliveries:", this.deliveries);

      // Map deliveries to events format
      const events = this.deliveries
        .filter((delivery) => delivery.deliveryDate) // Filter out invalid dates
        .map((delivery) => {
          let colorClass;
          switch (delivery.deliveryStatus) {
            case "PENDING":
              colorClass = "#bd3736"; // Red for Pending
              break;
            case "DELIVERED":
              colorClass = "#accc67"; // Green for Completed
              break;
            case "INTRANSIT":
              colorClass = "#dd8b34"; // Orange for In Transit
              break;
              
              case "RETURNED":
              colorClass = "#9c9797";
              break;
              case "CANCELLED":
              colorClass = "#000000";
              break;
            default:
              colorClass = "#bd3736"; 
          }
          return {
            id: delivery.id,
            title: `Delivery (${delivery.deliveryStatus})`,
            start: delivery.deliveryDate.split("T")[0],
            end: delivery.deliveryDate.split("T")[0],
            allDay: true,
            textColor: "#fff", // Ensures text is visible on colored background
            backgroundColor: colorClass,
            borderColor: colorClass,
            extendedProps: {
              driverName: delivery.driverName,
              pickUpLocation: delivery.pickUpLocation,
              dropOffLocation: delivery.dropOffLocation,
              deliveryStatus: delivery.deliveryStatus,
            },
          };
        });


      // Update calendar options dynamically
      this.calendarOptions.events = events;
      console.log("Final Events for Calendar:", events);
    } catch (error) {
      console.error("Error fetching data:", error);
    }

  }


};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
<style>
.custom-event-card {
  padding: 10px;
  border-radius: 5px;
  color: white;
  font-size: 12px;
  line-height: 1.5;
  text-align: left;
}
</style>